import { initFooterSection } from "@/modules/section-footer";
import ready from "@/scripts/helpers/dom/ready";
import cookiePopup from "@/modules/popup-cookie";
import { headerFunctions } from "@/modules/section-header";


if (document.querySelectorAll('.card')) {
  const cards = document.querySelectorAll('.card');
  cards.forEach(card => {
    card.addEventListener('click', e => {
      if (card.hasAttribute('href')) {
        window.location.href = card.getAttribute('href');
      }
      else if (card.querySelector('.card__title-link')) {
        window.location.href = card.querySelector('.card__title-link').getAttribute('href');
      }
      else if (card.querySelector('.card__title-link')) {
        window.location.href = card.querySelector('.card__title-link').getAttribute('href');
      }
    });
  });
};


ready( () => {
  headerFunctions();
  initFooterSection();
  setTimeout(() => {
    cookiePopup();
  }, 4000);
});